import { selectedBranchPoli, selectedPoli } from '../core/poli'

const SelectPoli = () => import('../pages/poli/SelectPoli.vue')
const SelectBranchPoli = () => import('../pages/poli/SelectBranch.vue')
const SelectDoctorPoli = () => import('../pages/poli/SelectDoctor.vue')
const CheckoutPoli = () => import('../pages/poli/Checkout.vue')
const SummaryPoli = () => import('../pages/poli/Summary.vue')
const AnamnesaPoli = () => import('../pages/poli/Anamnesa.vue')

export default [
  {
    path: '/poli',
    name: 'SelectPoli',
    meta: { requiresAuth: true },
    component: SelectPoli
  },
  {
    path: '/poli/pilih-cabang',
    name: 'SelectBranchPoli',
    meta: { requiresAuth: true },
    component: SelectBranchPoli,
    beforeEnter: (to, from, next) => {
      if (!selectedPoli.value) {
        return next({
          name: 'SelectPoli'
        })
      }

      next()
    }
  },
  {
    path: '/poli/pilih-dokter',
    name: 'SelectDoctorPoli',
    meta: { requiresAuth: true },
    component: SelectDoctorPoli,
    beforeEnter: (to, from, next) => {
      if (!selectedBranchPoli.value) {
        return next({
          name: 'CheckoutPoli'
        })
      }

      next()
    }
  },
  {
    path: '/poli/checkout',
    name: 'CheckoutPoli',
    meta: { requiresAuth: true },
    component: CheckoutPoli,
    beforeEnter: (to, from, next) => {
      if (!selectedPoli.value && !to.query.poli) {
        return next({
          name: 'SelectPoli'
        })
      }

      next()
    }
  },
  {
    path: '/poli/summary',
    name: 'SummaryPoli',
    meta: { requiresAuth: true },
    component: SummaryPoli
  },
  {
    path: '/poli/anamnesa/:anamnesaCode',
    name: 'AnamnesaPoli',
    meta: { requiresAuth: true },
    component: AnamnesaPoli
  }
]
